import AddNewBankContainer from 'containers/Banks/AddNewBank'
import React from 'react'

const AddNewBankPage = () => {
  return <AddNewBankContainer />
}

export default AddNewBankPage
